import React from 'react';
import Api from '../../api';
import { onError } from '../../libs/error-lib';
import { useRefreshScore } from '../../libs/hooks-lib';
import { useAppContext } from '../../libs/context-lib';
import TimelineScoreBoard from 'boss-ui/src/containers/TimelineScoreBoard';

const API = new Api();


export default function TimelineBoard({ eventId }) {
  const { user } = useAppContext();
  return <TimelineScoreBoard eventId={eventId} onError={onError} user={user} api={API}
                             useRefreshScore={useRefreshScore} isAdmin={true} />;
}
